module.exports = __webpack_public_path__ + "img/tubal-ligation.f00eb894.png";